import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Button, Col, Input, Row } from 'antd';
import { spacing } from '../../lib/theme';
import { fetchReviewReplies } from '../../actions';

import Loading from '../Common/Loading';
import ReviewReply from './ReviewReply';

class ReviewReplies extends Component {
    componentDidMount() {
        const { review } = this.props;
        this.props.fetchReviewReplies(review);
    }

    render() {
        const { loadingReviewReplies } = this.props.loadingState;
        if (loadingReviewReplies) {
            return <Loading />
        }

        const { reviewReplies, review } = this.props;
        console.dir(reviewReplies);
        const currentReviewReplies = reviewReplies[`${review.id}`] || {};
        console.dir(currentReviewReplies);
        const comments = currentReviewReplies.comments || {};
        const sortedComments = Object.keys(comments).sort();

        return (
            <div style={{ padding: `0 0 ${spacing('xs')} ${spacing('xl')}` }}>
                {sortedComments.map((commentId, index) => (
                    // <p key={index}>{comment.comment}</p>
                    <ReviewReply review={review} commentId={commentId} comment={comments[commentId]} key={index} />
                ))}
            </div>
        )
    }
}

ReviewReplies.propTypes = {
    fetchReviewReplies: PropTypes.func,
    userDetails: PropTypes.object,
    loadingState: PropTypes.object,
    reviewReplies: PropTypes.object,
    review: PropTypes.object,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        loadingState: state.loadingState,
        reviewReplies: state.reviewRepliesState,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        // replyReview: bindActionCreators(replyReview, dispatch),
        fetchReviewReplies: bindActionCreators(fetchReviewReplies, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewReplies);